module.exports = __webpack_public_path__ + "static/media/speech-bubble.ef83d29f.svg";